import { useState } from 'react'
import FormPage from '../../../../Components/Form/Page/FormPage'
import useBriefContext from '../../../../Hooks/Brief/useBriefContext'
import { LocationAttributes } from '../../../../Types/Location'
import BaseLocationInput from '../Base'
import InputView from '../../InputView'
import { getDefaultLocationAttrs, LocationAttributesWithoutRadius } from '../Base/LocationInput'
import { BIZ_DEFAULT_RADIUS } from '../../../../Constants'

const LocationInput: InputView = ({ path }) => {
  const {brief} = useBriefContext()
  const [location, setLocation] = useState<
      LocationAttributesWithoutRadius | undefined
    >(getDefaultLocationAttrs(brief))
  const [radius, setRadius] = useState<LocationAttributes['radius']>(
    brief.radius ?? BIZ_DEFAULT_RADIUS
  )
  const allLocationAttrs = {radius, ...(location && location)}

  return (
    <FormPage
      metaTitle='Location - HeadBox'
      heading='What location works best?'
      path={path}
      inputAttributes={allLocationAttrs}
      className='location-input biz'
      >
      <BaseLocationInput
        radius={radius}
        locationAttributes={location}
        setLocation={setLocation}
        setRadius={setRadius}
        />
    </FormPage>
  )
}

export default LocationInput
